module.exports = __webpack_public_path__ + "img/fruit-nectarines-350x184.3821db6e.jpg";